export enum SubscriptionLevelType {
  Level1 = 1,
  Level2 = 2,
}
